import { PageViewEventLogger, useUserEventLogger } from '@repo/tracking-service';
import { AuthGuard } from '@repo/user-session';
import { useRouter } from 'next/router';

import Layout from '@/components/layout/Layout';
import HometaxUnavailableTimeError from '@/components/tax-refund/common/view/ErrorView/HometaxUnavailableTimeError';
import { COMMON_PATHS } from '@/lib/constants/paths';

const CorporationHometaxImpossibleErrorPage = () => {
  const router = useRouter();
  const { sendClickEvent } = useUserEventLogger();

  const handleClickExit = () => {
    sendClickEvent('corps-lookup_error-impossible_close');
    router.push({
      pathname: `${COMMON_PATHS.환급조회목록}`,
      query: router.query
    });
  };

  return (
    <AuthGuard>
      <PageViewEventLogger pageName="corps-lookup_error-impossible" />
      <Layout>
        <HometaxUnavailableTimeError onPrimaryButtonClick={handleClickExit} />
      </Layout>
    </AuthGuard>
  );
};

export default CorporationHometaxImpossibleErrorPage;
